<template>
  <div id="app" >
    <div
      v-loading="loading"
      element-loading-background="rgba(0, 0, 0, 0.7)"
      :class="{none:loading}"
      style="display: none;">
      <!-- 这里是你的内容 -->
    </div>
    <div class="liukou-info">
      <el-input
        class="order"
        v-model="order"
        placeholder="流冠订单编号"
        type="textarea"
      ></el-input>
      <el-input
         class="order"
        v-model="password"
        placeholder="流寇订单密码"
        type="textarea"
      ></el-input>
      <el-input
        v-model="requestPassword"
        placeholder="访问密码"
        type="textarea"
      ></el-input>
    </div>
    <div>
      
      流冠网址https://www.hailiangip.com/
      <span style="color: red" >注意一定要买流量订单1g30元的那个，不要买金币订单。买了金币订单就会无法使用</span
      >
    </div>
    <div style="color:red;margin-top: 10px;">
      存入本地仓库为存在浏览器缓存中，清除缓存或者更换浏览器均会清空,本地仓库的预测功能并非百分百正确，介意勿用.提卡用卡时必须使用本地仓库的预测功能，否则会导致预测结果全部错误!!!
      <span style="color: #67c23a;">可以使用同步爱奇艺服务器功能纠正</span>
    </div>
    <div class="check">
      <el-input
        v-model="input"
        placeholder="一个链接一行，配置了流寇ip才能使用，请购买流冠的流量订单，比较划算"
        type="textarea"
      ></el-input>

      <el-button
        style="margin-left: 20px"
        type="primary"
        @click="getLinkInfo"
        :disabled="loading"
        >{{ loading ? "正在查询" : "检查天数" }}
      </el-button>
      <el-button
        style="margin-left: 20px"
        type="primary"
        @click="createdXlsx"
        :disabled="loading"
        >91卡券-剩余包导出
      </el-button>
      <el-button  type="primary" style="margin-left: 20px" @click="saveLocal" :disabled="loading">存入本地仓库</el-button>
      <el-button  type="primary" style="margin-left: 20px" @click="checkLocal">查看本地仓库</el-button>
    </div>
    <div style="color:green;margin-bottom: 10px;">点击下方标签即可下载对应文件</div>
    <div class="info">
      <el-tag @click="arrayToTxtFile(v5,'v5')">v5：{{ v5.length }}</el-tag>
      <el-tag @click="arrayToTxtFile(v6,'v6')">v6：{{ v6.length }}</el-tag>
      <el-tag @click="arrayToTxtFile(v7,'v7')">v7：{{ v7.length }}</el-tag>
    </div>
    <div class="info">
      <el-tag type="success" @click="arrayToTxtFile(unclaimedNum,'未领取')">未领取：{{ unclaimedNum.length }}</el-tag>
      <el-tag type="danger" @click="arrayToTxtFile(expireNum,'过期')">过期：{{ expireNum.length }}</el-tag>
      <el-tag type="warning" @click="arrayToTxtFile(abnormalNum,'异常')">异常：{{ abnormalNum.length }}</el-tag>
      <el-tag type="info" @click="arrayToTxtFile(finishNum,'领完')">领完：{{ finishNum.length }}</el-tag>
    </div>
    共{{ totalNum }}条数据---<span style="color: #67c23a;">{{this.tableData.length}}</span>条有效数据(<span style="color:red;cursor: pointer;" @click="arrayToTxtFile(duplicateItems,'重复项')">{{ duplicateItems.length }}</span>条重复,点击数字下载)
    <span v-if="errors.length>0" style="color: red;cursor: pointer;" @click="arrayToTxtFile(errors,'查询失败')">查询失败{{errors.length}}条，请下载检查链接是否正确</span>
    <el-table :data="tableData" style="width: 100%" >
      <el-table-column prop="link" label="链接"> </el-table-column>
      <el-table-column prop="day" label="到期天数">
        <template slot-scope="scope">
          <span v-if="scope.row.day > 5">剩余{{ scope.row.day }}天</span>
          <span v-else-if="scope.row.day >= 0 && scope.row.day <= 5"
            >临期-{{ scope.row.day }}天</span
          >
          <span v-else class="red">过期</span>
        </template>
      </el-table-column>
      <el-table-column prop="receivedNum" label="已领数量" width="180">
      </el-table-column>
      <el-table-column prop="surplusNum" label="剩余数量"> </el-table-column>
      <el-table-column prop="surplusNum" label="剩余未领取天数">
        <template slot-scope="scope">
          {{ surplusDay(scope.row) }}
        </template>
      </el-table-column>
      <el-table-column prop="totalNum" label="总数量"> </el-table-column>
      <el-table-column prop="success" label="是否领完">
        <template slot-scope="scope">
          <el-tag
            type="danger"
            v-if="scope.row.receivedNum == scope.row.totalNum"
            >领完</el-tag
          >
          <el-tag type="warning" v-else-if="scope.row.receivedNum > 0"
            >异常</el-tag
          >
          <el-tag type="success" v-else>未领取</el-tag>
        </template>
      </el-table-column>
    </el-table>
    <Storehouse ref="storehouse"></Storehouse>
 
  </div>
</template>

<script>
import * as XLSX from '../xlsx.full.min.js';
import Storehouse from './Storehouse'

export default {
  name: "App",
  components:{Storehouse},
  data() {
    return {
      input: "",
      tableData: [],
      loading: false,
      order: "",
      password: "",
      totalNum:0,
      duplicateItems:[],
      errors:[],
      requestPassword:'',
      predictDayResult:[],
    };
  },
  computed: {
    surplusDay(){
      return function(item){
        const sumDay = item.totalNum==3?5:item.totalNum==5?10:30
       if(item.receivedDays.length===0) return sumDay
        const sum = item.receivedDays.reduce((prev, curr)=>{
        return prev + curr;
      });
        return sumDay-sum
      }
    },
    unclaimedNum() {
      return this.tableData.filter((item) => item.receivedNum === 0&&item.day >= 0&&item.totalNum!=0);
    },
    expireNum() {
      return this.tableData.filter((item) => item.day < 0);
    },
    abnormalNum() {
      return this.tableData.filter(
        (item) => item.receivedNum > 0 && item.receivedNum < item.totalNum && item.day >= 0
      );
    },
    finishNum() {
      return this.tableData.filter((item) => item.receivedNum === item.totalNum && item.day >= 0);
    },
    v5() {
      return this.tableData.filter((item) => item.totalNum == 3);
    },
    v6() {
      return this.tableData.filter((item) => item.totalNum == 5);
    },
    v7() {
      return this.tableData.filter((item) => item.totalNum == 10);
    },
    validData(){
      return this.tableData.filter((item) => item.receivedNum >= 0&&item.day >= 0&&item.totalNum!=0&&item.receivedNum<item.totalNum);
    },
    unclaimedNumV5(){
      return this.validData.filter((item) => item.totalNum == 3);
    },
    unclaimedNumV6(){
      return this.validData.filter((item) => item.totalNum == 5);
    },
    unclaimedNumV7(){
      return this.validData.filter((item) => item.totalNum == 10);
    },
  },
  created() {
    this.order = window.localStorage.getItem("order");
    this.password = window.localStorage.getItem("password");
    this.requestPassword = window.localStorage.getItem("requestPassword");
  },
  methods: {
    createdXlsx(){
      if(this.validData.length===0){
        this.$message({
            message: "请先查询获取有效数据",
            type: "warning",
          });
        return
      }
      const workbook = XLSX.utils.book_new();
      const v5 = this.generateSurplusNum(this.unclaimedNumV5,5);
      const v6 = this.generateSurplusNum(this.unclaimedNumV6,6);
      const v7 = this.generateSurplusNum(this.unclaimedNumV7,7);
      this.generateTable(v5,workbook,'v5')
      this.generateTable(v6,workbook,'v6')
      this.generateTable(v7,workbook,'v7')
      XLSX.writeFile(workbook, `导出数据${new Date().getTime()}.xlsx`, { compression: true });
    },
    saveLocal(){
      if(this.validData.length==0) {
        this.$message({
            message: "请先查询获取有效数据",
            type: "warning",
          });
        return
      }
      this.predictDayResult = []
      this.setPredictDayForV5()
      this.setPredictDayForV6()
      this.setPredictDayForV7()
      const localData = JSON.parse(window.localStorage.getItem('aqyData'))||[]
      const localRedNos = localData.reduce((prev, cur, index)=>{
        prev[cur.redNo] = cur
        return prev
      },{})

      this.predictDayResult.forEach(item=>localRedNos[item.redNo] = item)
      this.tableData.forEach(item=>{
        const {receivedNum,totalNum,redNo} = item
        if(receivedNum==totalNum&&localRedNos[redNo]) delete localRedNos[redNo]
      })
      window.localStorage.setItem('aqyData',JSON.stringify(Object.values(localRedNos)))
      this.$message({
        message: '存入成功，重复数据会直接更新',
        type: "success",
      });
    },
    checkLocal(){
      this.$refs.storehouse.drawer = true
    },
 
    addPredictDayByLaw(item,law){
      const { receivedNum } = item

      this.predictDayResult.push({
        ...item,
        name:this.getName(law[receivedNum]),
        type:this.getType(law[receivedNum]),
        law,
      })
      
    },
    getName(day){
      if(day==1) return '一天卡'
      else if(day==2) return '两天卡'
      else return '三天卡'
    },
    getType(day){
      if(day==1) return 'one'
      else if(day==2) return 'two'
      else return 'three'
    },
  
    getLastDay(item){
    
      const { receivedDays} = item
     
      const day = this.surplusDay(item)
      const law = JSON.parse(JSON.stringify(receivedDays))
      law.push(day)
      receivedDays[receivedDays.length-1] = day
      this.predictDayResult.push({
        ...item,
          name:this.getName(day),
          type:this.getType(day),
          law
      })
    },
    setPredictDayForV5(){
      const v5Law = [2,1,2]
      const v5Law1 = [1,3,1]
      this.unclaimedNumV5.forEach(item=>{
        const { receivedNum } = item
        if(receivedNum==2){
          this.getLastDay(item) 
          return 
        }

        if(receivedNum[0]==v5Law1[0]){
          this.addPredictDayByLaw(item,v5Law1)
          return
        }

        this.addPredictDayByLaw(item,v5Law)
      })
    },
    setPredictDayForV6(){
      const v6Law = [2,2,2,1,1]
     
      this.unclaimedNumV6.forEach(item=>{
        const { receivedNum } = item
        if(receivedNum==4){
          this.getLastDay(item) 
          return 
        }
        this.addPredictDayByLaw(item,v6Law)
      })
    },
    setPredictDayForV7(){
      const v7Law = [3,3,3,3,3,3,3,1,1,1]
      this.unclaimedNumV7.forEach(item=>{
        const { receivedNum } = item
        if(receivedNum==9){
          this.getLastDay(item) 
          return 
        }
        this.addPredictDayByLaw(item,v7Law)
      })
    },
   
    generateTable(links,workbook,lv){
      const utils = XLSX.utils;
      const sheetOpts = {
        header:['link','day','surplusNum','receivedNum','totalNum']
      }
      const titles = ["链接", "过期天数",'剩余数量','已领数量','总数量','是否领完']
      const sheet = utils.json_to_sheet(links,sheetOpts);
      utils.book_append_sheet(workbook, sheet, lv);
      utils.sheet_add_aoa(sheet, [[`此表为${lv}红包，已经领完的红包自动剔除，数据按照过期天数升序，并且已经根据链接剩余包的数量生成了对应数量的链接,可去下方表名查看其他等级`,,,,,]], { origin: "A1" });
      utils.sheet_add_aoa(sheet, [titles], { origin: "A2" });
      sheet["!cols"]=[ { wch: 118 } ];
      sheet["!merges"] = [XLSX.utils.decode_range("A1:G1")];
    },
    generateSurplusNum(links){
      let  generateLinkBysurplusNum = []
      links.forEach(item=>{
        const {surplusNum} = item
        for(let i=0;i<surplusNum;i++){
          generateLinkBysurplusNum.push(item)
        }
      })
      generateLinkBysurplusNum.unshift({"link": "","receivedNum": 1,"surplusNum": 9,"totalNum": 10,"success": false,"day": 11 })
      return generateLinkBysurplusNum
    },
    arrayToTxtFile(array, filename) {
      if(array.length==0||!array) return
      // 将数组转换为字符串，每个元素一行
      var text = array.map(item=>item.link).join("\n");
      // 创建新的Blob对象，设置文本内容类型
      var blob = new Blob([text], { type: "text/plain;charset=utf-8" });

      // 创建一个指向Blob的URL
      var url = URL.createObjectURL(blob);

      // 创建一个a元素，设置属性并添加到文档
      var link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${filename}-${array.length}`);
      document.body.appendChild(link);

      // 触发下载
      link.click();

      // 清理并移除元素和URL引用
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },
    async getLinkInfo() {
      if (this.loading || !this.input) return;
      const links = this.input.split("\n")
      // if(links&&links.length>1500){
      //   this.$message({
      //         message: '最多只能1500个链接',
      //         type: "warning",
      //       });
      //       return
      // }
      this.loading = true;
      return await fetch(`/api`, {
        method: "post",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          links: this.input,
          order: this.order,
          requestPassword:this.requestPassword,
          password: this.password,
        }),
      })
        .then((response) => response.json())
        .then((res) => {
          if (res.code === 200) {
            this.errors = res.data.filter(item=>item.error)
            const successList = res.data.filter(item=>!item.error)

            const redNos = successList.filter(item=>!item.error).map(item=>item.redNo)
            const duplicateItems = []
            const validData = []
            redNos.forEach((value, index, self) => {
                // validData.push(successList[index])
              if(self.indexOf(value) === index){
                validData.push(successList[index])
              }else{
                duplicateItems.push(successList[index])
              }
            });
            this.tableData = validData.sort((a,b)=>a.day-b.day)
            this.totalNum = successList.length
            this.duplicateItems = duplicateItems
            this.$message({
              message: res.message,
              type: "success",
            });
            window.localStorage.setItem("order", this.order);
            window.localStorage.setItem("password", this.password);
            window.localStorage.setItem("requestPassword", this.requestPassword);
            this.loading = false;
            return true
          } else {
            this.$message({
              message: res.message,
              type: "warning",
            });
            this.loading = false;
            return false
          }

        })
        .catch((error) => {
          this.loading = false;
          this.$message({
            message: "服务异常，请联系作者",
            type: "warning",
          });
        });
    },
    isValidHttpUrl(string) {
      let url;
      try {
        url = new URL(string);
      } catch (_) {
        return false;
      }
      return url.protocol === "http:" || url.protocol === "https:";
    },
  },
};
</script>

<style>
.none{
  display: block !important;
  position: fixed; width: 100%; height: 100%; z-index: 9999;left: 0;top: 0;
}
#app {
  text-align: center;
  color: #2c3e50;
  margin: 20px;
}
.check {
  display: flex;
  margin-bottom: 30px;
}
#app .liukou-info {
  display: flex;
}
.liukou-info .order {
  margin-right: 20px;
}
.red {
  color: red;
}
.info {
  margin-bottom: 20px;
}
.info .el-tag{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/App.vue